// Recursively finds a chart-of-account name by Id, searching SubAccounts.
export function findNameById(arr, targetId) {
  for (const item of arr) {
    if (item.Id === targetId) {
      return item.Name;
    }
    if (item.SubAccounts) {
      const result = findNameById(Object.values(item.SubAccounts), targetId);
      if (result !== "Chart of Account") {
        return result;
      }
    }
  }
  return "Chart of Account";
}
